
import React, { useState, useRef, useEffect } from "react";
import { Stage, Layer, Image as KonvaImage, Arrow } from "react-konva";
import { Html } from "react-konva-utils";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { BASEURL } from "../../../../../constants";

const IMAGE_WIDTH = 600;
const IMAGE_HEIGHT = 400;
const INPUT_WIDTH = 100;
const INPUT_HEIGHT = 20;
const PADDING = 10;

const clamp = (value, min, max) => Math.max(min, Math.min(value, max));

const CategorySelector = ({ setCurrentSlideData, contentId, data }) => {
    const [state, setState] = useState({
        id: "",
        image: "", // Store image URL
        imageKey: "",
        annotations: [],
    });

    const [loadedImage, setLoadedImage] = useState(null); // Store the loaded image object
    const [isDrawing, setIsDrawing] = useState(false);
    const [startPos, setStartPos] = useState(null);
    const [hasDragged, setHasDragged] = useState(false);
    const stageRef = useRef(null);

    // Load the image when the state.image changes
    // useEffect(() => {
    //     if (state.image) {
    //         const img = new window.Image();
    //         img.src = state.image;
    //         img.onload = () => {
    //             setLoadedImage(img); // Set the loaded image
    //         };
    //     } else {
    //         setLoadedImage(null); // Reset if no image
    //     }
    // }, [state.image]);



    useEffect(() => {
        if (data) {

            fetchOptionImageUrl(data)

        } else {

            setState({
                id: "",
                image: "", // Store image URL
                imageKey: "",
                annotations: [],
            });
            setLoadedImage(null)
        }
    }, []);

    async function fetchOptionImageUrl(data) {
        if (data.imageKey) {
            const imageResponse = await axios.get(`${BASEURL}/api/get-image`, {
                params: {
                    imageId: data.imageKey,
                }
            })
            if (imageResponse.data?.dataUrl) {
                
                const img = new window.Image();
                img.src = imageResponse.data?.dataUrl;

                img.onload = () => {
                    setLoadedImage(img); // Set the loaded image
                };
            } else {
                setLoadedImage(null); // Reset if no image
            }
            setState({ ...data, image: imageResponse.data?.dataUrl })

        }

    }

    useEffect(() => {
        setCurrentSlideData((currentSlideData) => {
            let newCurrentSlideData = {
                ...currentSlideData,
                content: currentSlideData.content.map((contentObj) => {
                    if (contentObj.id === contentId) {
                        return { ...contentObj, data: state };
                    } else {
                        return contentObj;
                    }
                }),
            };
            return newCurrentSlideData;
        });
    }, [state]);

    useEffect(() => {
        if (data) {
            setState(data);
        }
    }, []);

    const handleImageUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        try {
            const uniqueId = uuidv4();
            const formData = new FormData();
            formData.append('image', file);
            formData.append('id', uniqueId);

            // Upload image
            await axios.post(`${BASEURL}/api/upload-image`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            // Fetch the uploaded image URL
            const imageResponseObject = await axios.get(`${BASEURL}/api/get-image`, {
                params: { imageId: uniqueId }
            });

            // Update state with the image URL and unique key
             if (imageResponseObject.data?.dataUrl) {
                
                const img = new window.Image();
                img.src = imageResponseObject.data?.dataUrl;

                img.onload = () => {
                    setLoadedImage(img); // Set the loaded image
                };
            } else {
                setLoadedImage(null); // Reset if no image
            }
            setState((prev) => ({
                ...prev,
                image: imageResponseObject.data?.dataUrl || "",
                imageKey: uniqueId
            }));

        } catch (error) {
            console.error("Error uploading or fetching image:", error);
        }
    };

    const handleImageDelete = (image_key) => {
        if (image_key) {
            axios.delete(`${BASEURL}/api/delete-image`, {
                data: { key: image_key }
            })
                .then(() => {
                    // Successfully deleted the image, reset state
                    setState((prevState) => ({
                        ...prevState,
                        image: "", // Reset image URL
                        imageKey: "", // Reset image key
                        annotations: [], // Clear annotations
                    }));
                })
                .catch((error) => {
                    console.error("Error deleting image:", error);
                });
        }
    };

    const handleMouseDown = (event) => {
        const pos = event.target.getStage().getPointerPosition();
        setStartPos(pos);
        setIsDrawing(true);
        setHasDragged(false);
    };

    const handleMouseMove = (event) => {
        if (!isDrawing) return;

        const pos = event.target.getStage().getPointerPosition();
        if (Math.abs(pos.x - startPos.x) > 5 || Math.abs(pos.y - startPos.y) > 5) {
            setHasDragged(true);
        }
    };

    const handleMouseUp = (event) => {
        if (!isDrawing || !hasDragged) {
            setIsDrawing(false);
            return;
        }

        const pos = event.target.getStage().getPointerPosition();
        setState((prev) => ({
            ...prev,
            annotations: [
                ...prev.annotations,
                { id: prev.annotations.length + 1, startX: startPos.x, startY: startPos.y, endX: pos.x, endY: pos.y, text: "" },
            ],
        }));
        setIsDrawing(false);
    };

    const handleInputChange = (e, index) => {
        const updatedAnnotations = [...state.annotations];
        updatedAnnotations[index].text = e.target.value;
        setState((prev) => ({ ...prev, annotations: updatedAnnotations }));
    };

    const handleUndo = () => {
        if (state.annotations.length > 0) {
            setState((prev) => ({
                ...prev,
                annotations: prev.annotations.slice(0, -1),
            }));
        }
    };

    return (
        <div className="font-sans">
            <h1 className="text-2xl font-bold mb-4">Category Creator</h1>

            {!state.image && (
                <input
                    type="file"
                    onChange={handleImageUpload}
                    accept="image/*"
                    className="mb-2 p-2 border border-gray-300 rounded-md w-full"
                />
            )}

            {state.image && (
                <div className="relative border border-gray-300 rounded-md overflow-hidden inline-block">
                    <div className="absolute top-0 right-0 flex items-center space-x-[6px] p-1 z-10">
                        <button
                            onClick={handleUndo}
                            className={`bg-gray-500 text-white flex items-center justify-center p-1 rounded-full hover:bg-gray-600 disabled:opacity-50 ${state.annotations.length === 0 && "hidden"}`}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                width="18"
                                height="18"
                            >
                                <path d="M12 5V1L4 8l8 7V11c3.87 0 7 3.13 7 7 0 1.3-.35 2.52-.96 3.57l1.46 1.46C21.29 20.85 22 18.99 22 17c0-5.52-4.48-10-10-10z" />
                            </svg>
                        </button>
                        <button
                            onClick={() => handleImageDelete(state.imageKey)}
                            className="bg-red-500 text-white p-1 rounded-full hover:bg-red-600 flex items-center justify-center"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <Stage
                        width={IMAGE_WIDTH}
                        height={IMAGE_HEIGHT}
                        onMouseDown={handleMouseDown}
                        onMouseMove={handleMouseMove}
                        onMouseUp={handleMouseUp}
                        ref={stageRef}
                    >
                        <Layer>
                            {loadedImage && (
                                <KonvaImage
                                    image={loadedImage}
                                    width={IMAGE_WIDTH}
                                    height={IMAGE_HEIGHT}
                                />
                            )}
                            {state.annotations.map((ann, index) => {
                                let inputLeft =
                                    ann.endX > ann.startX ? ann.endX + PADDING : ann.endX - (INPUT_WIDTH + PADDING);
                                let inputTop = ann.endY - INPUT_HEIGHT / 2;

                                inputLeft = clamp(inputLeft, PADDING, IMAGE_WIDTH - (INPUT_WIDTH + PADDING));
                                inputTop = clamp(inputTop, PADDING, IMAGE_HEIGHT - (INPUT_HEIGHT + PADDING));

                                return (
                                    <React.Fragment key={index}>
                                        <Arrow
                                            points={[ann.endX, ann.endY, ann.startX, ann.startY]}
                                            stroke="red"
                                            strokeWidth={2}
                                            pointerLength={8}
                                            pointerWidth={8}
                                        />
                                        <Html>
                                            <input
                                                type="text"
                                                value={ann.text}
                                                onChange={(e) => handleInputChange(e, index)}
                                                className="absolute border border-gray-500 rounded-md p-1 text-sm bg-white"
                                                style={{
                                                    left: `${inputLeft}px`,
                                                    top: `${inputTop}px`,
                                                    width: `${INPUT_WIDTH}px`,
                                                }}
                                            />
                                        </Html>
                                    </React.Fragment>
                                );
                            })}
                        </Layer>
                    </Stage>
                </div>
            )}
        </div>
    );
};

export default CategorySelector;
